import axios, {AxiosResponse} from 'axios'

const API_URL = process.env.REACT_APP_THEME_API_URL

// ─── Interfaces ───────────────────────────────────────────────────────────────

export interface ProfitCenter {
  profit_center_id: number
  company_id: number
  center_code: string
  center_name: string
  business_unit: string
  center_head: string
  target_revenue: number
  target_profit_margin: number
  location: string
  status: string
  description: string
}

// ─── Profit Center APIs ───────────────────────────────────────────────────────

export const getProfitCenters = async (companyId: string): Promise<ProfitCenter[] | undefined> => {
  return await axios
    .get(`${API_URL}/profit-center/${companyId}/list`)
    .then((response: AxiosResponse<ProfitCenter[]>) => response.data)
    .then((response: ProfitCenter[]) => response)
}

export const createProfitCenter = async (body: any): Promise<{detail: string} | undefined> => {
  try {
    const response = await axios.post(`${API_URL}/profit-center/create`, body)
    return response.data
  } catch (error: any) {
    if (error.response) {
      throw error.response.data
    }
  }
}

export const deleteProfitCenter = async (
  companyId: string,
  profitCenterId: number
): Promise<{detail: string} | undefined> => {
  return await axios
    .delete(`${API_URL}/profit-center/${companyId}/${profitCenterId}`)
    .then((response: AxiosResponse<{detail: string}>) => response.data)
    .then((response: {detail: string}) => response)
}
